export const USER_LOGGED = 'USER_LOGGEDIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const NEW_FILE_LOADING = 'NEW_FILE_LOADING';
export const NEW_FILE_LOADED = 'NEW_FILE_LOADED';
export const NEW_FILE_FAILED = 'NEW_FILE_FAILED';
export const DELETE_FILES = 'DELETE_FILES';

const redux = (state, action) => {
  const { payload, type } = action;

  switch (type) {
    case USER_LOGGED:
      return {
        ...state,
        user: payload,
      };
    case USER_LOGOUT:
      localStorage.clear();
      return {
        ...state,
        user: null,
      };

    case NEW_FILE_LOADING:
      payload.loading = true;
      return {
        ...state,
        files: [payload, ...state.files],
      };

    case NEW_FILE_LOADED:
      payload.loading = false;

      const oldFile = state.files.find(({ id }) => id === payload.id);

      if (!oldFile) {
        return {
          ...state,
        };
      }

      oldFile.loading = false;

      return {
        ...state,
        files: [{ ...oldFile, ...payload }, ...state.files.filter(({ id }) => id !== payload.id)],
      };

    case NEW_FILE_FAILED:
      const failedFile = state.files.find(({ id }) => id === payload.id);
      failedFile.loading = false;
      failedFile.error = true;
      return {
        ...state,
      };

    case DELETE_FILES:
      return {
        ...state,
        files: [],
      };

    default:
      return state;
  }
};

export default redux;
